// Import main base js.
import 'BwFrontendTheme'


import './main.scss'



//////////////////
// WEBPACK FOOTER
// ./Resources/themes/orkladistributionpartner/index.js
// module id = 36
// module chunks = 0